var _rect, _rect2, _rect3, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMissedVisit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 26,
    viewBox: "0 0 28 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 0.5,
    width: 25,
    height: 25,
    rx: 12.5,
    fill: "#FEFEFF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 0.5,
    width: 25,
    height: 25,
    rx: 12.5,
    stroke: "#EE3248"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3071_32994",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 5,
    width: 16,
    height: 16
  }, _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 5,
    width: 16,
    height: 16,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3071_32994)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.3335 11.6634C15.3335 11.2967 15.203 10.9829 14.9419 10.7217C14.6808 10.4606 14.3669 10.3301 14.0002 10.3301C13.8891 10.3301 13.7835 10.3412 13.6835 10.3634C13.5835 10.3856 13.4891 10.4245 13.4002 10.4801L15.1835 12.2634C15.2391 12.1745 15.278 12.0801 15.3002 11.9801C15.3224 11.8801 15.3335 11.7745 15.3335 11.6634ZM18.1335 15.2134L17.1669 14.2467C17.4446 13.7801 17.653 13.344 17.7919 12.9384C17.9308 12.5329 18.0002 12.1523 18.0002 11.7967C18.0002 10.5856 17.6141 9.59397 16.8419 8.82174C16.0696 8.04952 15.1224 7.66341 14.0002 7.66341C13.5113 7.66341 13.053 7.73841 12.6252 7.88841C12.1974 8.03841 11.8113 8.25786 11.4669 8.54674L10.5169 7.59674C10.9946 7.18563 11.5335 6.87174 12.1335 6.65508C12.7335 6.43841 13.3558 6.33008 14.0002 6.33008C15.4113 6.33008 16.653 6.82452 17.7252 7.81341C18.7974 8.8023 19.3335 10.1301 19.3335 11.7967C19.3335 12.3301 19.2335 12.8773 19.0335 13.4384C18.8335 13.9995 18.5335 14.5912 18.1335 15.2134ZM15.5169 16.3967L10.0669 10.9467C10.0446 11.0801 10.028 11.219 10.0169 11.3634C10.0058 11.5079 10.0002 11.6523 10.0002 11.7967C10.0002 12.5856 10.328 13.4884 10.9835 14.5051C11.6391 15.5217 12.6446 16.6523 14.0002 17.8967C14.2891 17.6412 14.5585 17.3884 14.8085 17.1384C15.0585 16.8884 15.2946 16.6412 15.5169 16.3967ZM19.6502 20.5301L16.4502 17.3301C16.0946 17.7079 15.7169 18.0912 15.3169 18.4801C14.9169 18.869 14.478 19.2634 14.0002 19.6634C12.2113 18.1412 10.8752 16.7273 9.99186 15.4217C9.10853 14.1162 8.66686 12.9079 8.66686 11.7967C8.66686 11.4412 8.69464 11.1023 8.7502 10.7801C8.80575 10.4579 8.88353 10.1523 8.98353 9.86341L6.4502 7.33008L7.4002 6.38008L20.6002 19.5801L19.6502 20.5301Z",
    fill: "#EE3248"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMissedVisit);
export default __webpack_public_path__ + "static/media/MissedVisit.f660ed3ea5d7201994f3c777cd9f0c6d.svg";
export { ForwardRef as ReactComponent };